var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Tooltip as MuiTooltip, } from '@material-ui/core';
/**
 * Kareo wrapped component of the Material-UI Tooltip. The prop API has been limited to props defined in TooltipProps.
 *
 * Tooltips display informative text when users hover over, focus on, or tap an element.
 *
 * Material-UI Tooltip: [Tree Item](https://v4.mui.com/components/tooltips/), [API](https://https://v4.mui.com/api/tooltip/)
 *
 * @storybook: [Tooltip](http://design.kareoprod.ent/?path=/story/components-data-display-tooltip--tooltip-example)
 */
var Tooltip = function (props) {
    // CP-6740 NA: Implemented followCursor property and behavior based on: https://github.com/mui/material-ui/issues/14270
    // and MUI v5. This feature was added in MUI v5, so it will be available in the default MUI component after upgrade.
    var positionRef = React.useRef({
        x: 0,
        y: 0,
    });
    var popperRef = React.useRef(null);
    var followCursor = props.followCursor;
    var followCursorProps = followCursor
        ? {
            onMouseMove: function (e) {
                // Offset Y to account for `not-allowed` cursor height
                positionRef.current = { x: e.pageX, y: e.pageY + 20 };
                if (popperRef.current != null) {
                    popperRef.current.update();
                }
            },
            PopperProps: {
                popperRef: popperRef,
                anchorEl: {
                    clientHeight: 0,
                    clientWidth: 0,
                    getBoundingClientRect: function () { return ({
                        top: positionRef.current.y,
                        left: positionRef.current.x,
                        right: positionRef.current.x,
                        bottom: positionRef.current.y,
                        width: 0,
                        height: 0,
                    }); },
                },
            },
        }
        : null;
    return React.createElement(MuiTooltip, __assign({}, props, followCursorProps));
};
Tooltip.defaultProps = {};
export default Tooltip;
